module.exports = __webpack_public_path__ + "img/camion6.fa399e6d.jpg";